import * as React from 'react';
import { Draggable } from 'react-beautiful-dnd';

import './droppable-attachment-element.scss';

type Props = {
  id: number | string,
  index: number,
  children: React.ReactNode
};

const DroppableAttachmentElement = ({
  id,
  index,
  children
}: Props) => (
  <Draggable
    draggableId={String(id)}
    index={index}
  >
    {(provided, snapshot) => (
      <React.Fragment>
        <div
          className={(!snapshot.isDragging) ? 'droppable-attachment-element__not-transformable' : ''}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {children}
        </div>
        {snapshot.isDragging && (
          <div className="droppable-attachment-element__placeholder" />
        )}
      </React.Fragment>
    )}
  </Draggable>
);

export default DroppableAttachmentElement;
